import { AUTHENTICATION_ROUTES, isAuthRoute } from "./authentication";
import { DASHBOARD_ROUTES } from "./dashboard";
import { DIRECTOR_ROUTES } from "./director";
import { GENERAL_ROUTES } from "./general";
import { LANGUAGES_ROUTES } from "./languages";
import { PAYMENTS_ROUTES } from "./payments";
import { PROMOCODES_ROUTES } from "./promocodes";
import { TRANSLATIONS_ROUTES } from "./translations";

export const ROUTES = [
    ...AUTHENTICATION_ROUTES,
    ...DASHBOARD_ROUTES,
    ...DIRECTOR_ROUTES,
    ...GENERAL_ROUTES,
    ...PAYMENTS_ROUTES,
    ...TRANSLATIONS_ROUTES,
    ...LANGUAGES_ROUTES,
    ...PROMOCODES_ROUTES,
];

export { isAuthRoute };
